import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";

import { useForm } from "../../../Hooks/useForm";
import { toastShow } from "../../../Services/ToastService";
import Loader from "../../../Components/Loader/Loader";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";

import { EditarInformacionEmpresa, getInformacionEmpresa } from "../../../API/Global/InformacionEmpresa/InformacionEmpresaRequest";

const InformacionEmpresaCRUD = ({
  toastRef,
  showDialog,
  selected,
  setShowDialog,
  getInfo
}) => {
  const toast = useRef(null);
  const [infoEmpresa, setInfoEmpresa] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showLogos, setShowLogos] = useState(false);

  const [showLogosDialog, setShowLogosDialog] = useState(false);

  const initialValues = {
    IdEmpresa: -1,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const b = await getInformacionEmpresa();
    setInfoEmpresa(b);

    setValues({
      ...selected
    });
    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
  };

  const getImgSrc = (imagen) => {
    if (!imagen) return "";

    if (imagen.startsWith("data:image")) {
      return imagen;
    }

    if (imagen.startsWith("http") || imagen.startsWith("/")) {
      return imagen;
    }

    return `data:image/png;base64,${imagen}`;
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombreLegal) {
      error.NombreLegal = true;
      error.error = true;
    }
    if (!values.NombreCorto) {
      error.NombreCorto = true;
      error.error = true;
    }
    setError(error);
    return error;
  };

  const editarEmpresa = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const Datos = {
        IdEmpresa :  values.IdEmpresa,
        NombreLegal :  values.NombreLegal,
        NombreCorto :  values.NombreCorto,
        RTN :  values.RTN,
        Direccion :  values.Direccion,
        CorreoInformativo :  values.CorreoInformativo,
        CorreoVentas :  values.CorreoVentas,
        CorreoCompras :  values.CorreoCompras,
        Telefono :  values.Telefono,
        LogoPrimarioB64 :  values.LogoPrimarioB64,
        LogoPrimarioDarkB64 :  values.LogoPrimarioDarkB64,
        LogoPrimario :  values.LogoPrimario,
        LogoPrimarioDark :  values.LogoPrimarioDark,
        LogoPrimarioVertical :  values.LogoPrimarioVertical,
        LogoPrimarioVerticalDark : values.LogoPrimarioVerticalDark
      };

      console.log(Datos)
      setLoading(true);
      const resultado = await EditarInformacionEmpresa(Datos);
      if (resultado[0]?.ESTADO === 1) {
        toastShow(toast, "success", "Datos Editados", resultado[0]?.MENSAJE);
        getInfo();
        setTimeout(() => {
          onHide();
          setLoading(false);
        }, 1300);
      } else {
        toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
      }

    }
  };

  const guardarLogos = async () => {
    const Datos = {
      IdEmpresa: values.IdEmpresa,
      NombreLegal: values.NombreLegal,
      NombreCorto: values.NombreCorto,
      RTN: values.RTN,
      Direccion: values.Direccion,
      CorreoInformativo: values.CorreoInformativo,
      CorreoVentas: values.CorreoVentas,
      CorreoCompras: values.CorreoCompras,
      Telefono: values.Telefono,

      LogoPrimarioB64: values.LogoPrimarioB64,
      LogoPrimarioDarkB64: values.LogoPrimarioDarkB64,
      LogoPrimario: values.LogoPrimario,
      LogoPrimarioDark: values.LogoPrimarioDark,
      LogoPrimarioVertical: values.LogoPrimarioVertical,
      LogoPrimarioVerticalDark: values.LogoPrimarioVerticalDark,
    };

    setLoading(true);

    const resultado = await EditarInformacionEmpresa(Datos);

    if (resultado[0]?.ESTADO === 1) {
      toastShow(toast, "success", "Logos editados", resultado[0]?.MENSAJE);
      getInfo();
      setShowLogosDialog(false);
    } else {
      toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
    }

    setLoading(false);
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label="Ver logos"
        icon="pi pi-images"
        className="p-button-text"
        type="button"
        onClick={() => setShowLogosDialog(true)}
      />
      <Button
        label={"Editar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={editarEmpresa}
        loading={loading}
      />
    </React.Fragment>
  );

  const LogosDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        type="button"
        onClick={() => setShowLogosDialog(false)}
      />

      <Button
        label="Guardar logos"
        icon="pi pi-check"
        className="p-button-text"
        type="button"
        onClick={guardarLogos}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle =  "Editar Datos de la Empresa";

  return (
    <div>
      <ConfirmDialog />
      {/* Modal de informacion de la empresa*/}
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        >
        <Toast ref={toast} />
        <div id="Dialog">
            <Loader loading={loading} querySelector={"#Dialog"} />
            <div style={{ width: "100%", margin: "auto" }}>

              <div className="modal__input-contenedor">
                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="NombreLegal"
                      value={values.NombreLegal}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.NombreLegal ? "p-invalid" : ""}
                    />
                    <label htmlFor="NombreLegal">Nombre Legal</label>
                  </span>
                </div>

                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="NombreCorto"
                      value={values.NombreCorto}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.NombreCorto ? "p-invalid" : ""}
                    />
                    <label htmlFor="NombreCorto">Nombre Corto</label>
                  </span>
                </div>

                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="RTN"
                      value={values.RTN}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.RTN ? "p-invalid" : ""}
                    />
                    <label htmlFor="RTN">RTN</label>
                  </span>
                </div>
              </div>

              <div className="modal__input-contenedor">
                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="Direccion"
                      value={values.Direccion}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.Direccion ? "p-invalid" : ""}
                    />
                    <label htmlFor="Direccion">Direccion</label>
                  </span>
                </div>

                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="Telefono"
                      value={values.Telefono}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.Telefono ? "p-invalid" : ""}
                    />
                    <label htmlFor="Telefono">Teléfono</label>
                  </span>
                </div>

                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="CorreoInformativo"
                      value={values.CorreoInformativo}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.CorreoInformativo ? "p-invalid" : ""}
                    />
                    <label htmlFor="CorreoInformativo">Correo Informativo</label>
                  </span>
                </div>
              </div>

              <div className="modal__input-contenedor">
                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="CorreoVentas"
                      value={values.CorreoVentas}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.CorreoVentas ? "p-invalid" : ""}
                    />
                    <label htmlFor="CorreoVentas">Correo Ventas</label>
                  </span>
                </div>

                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="CorreoCompras"
                      value={values.CorreoCompras}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.CorreoCompras ? "p-invalid" : ""}
                    />
                    <label htmlFor="CorreoCompras">Correo Compras</label>
                  </span>
                </div>

                {/* <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="LogoPrimario"
                      value={values.LogoPrimario}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.LogoPrimario ? "p-invalid" : ""}
                    />
                    <label htmlFor="LogoPrimario">Logo Primario</label>
                  </span>
                </div> */}
              </div>

              {/* <div className="modal__input-contenedor">
                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="LogoPrimarioDark"
                      value={values.LogoPrimarioDark}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.LogoPrimarioDark ? "p-invalid" : ""}
                    />
                    <label htmlFor="LogoPrimarioDark">Logo Primario Sobre Oscuro</label>
                  </span>
                </div>

                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="LogoPrimarioVertical"
                      value={values.LogoPrimarioVertical}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.LogoPrimarioVertical ? "p-invalid" : ""}
                    />
                    <label htmlFor="LogoPrimarioVertical">
                      Logo Primario Vertical
                    </label>
                  </span>
                </div>

                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="LogoPrimarioVerticalDark"
                      value={values.LogoPrimarioVerticalDark}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={
                        error.LogoPrimarioVerticalDark ? "p-invalid" : ""
                      }
                    />
                    <label htmlFor="LogoPrimarioVerticalDark">
                      Logo Primario Vertical  Sobre Oscuro
                    </label>
                  </span>
                </div>
              </div>

              <div className="modal__input-contenedor">
                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="LogoPrimarioB64"
                      value={values.LogoPrimarioB64}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.LogoPrimarioB64 ? "p-invalid" : ""}
                    />
                    <label htmlFor="LogoPrimarioB64">Logo Primario B64</label>
                  </span>
                </div>

                <div className="field col-4 me-2">
                  <span className="p-float-label">
                    <InputText
                      name="LogoPrimarioDarkB64"
                      value={values.LogoPrimarioDarkB64}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                      abelStyle={{
                        color: "gray",
                        textShadow: "0px 0px 1px white",
                      }}
                      className={error.LogoPrimarioDarkB64 ? "p-invalid" : ""}
                    />
                    <label htmlFor="LogoPrimarioDarkB64">
                      Logo Primario Sobre Oscuro B64
                    </label>
                  </span>
                </div>
              </div> */}

            </div>
        </div>
      </Dialog>

      {/* Modal Para ver los Logos. */}
      <Dialog
        header="Vista de Logos"
        visible={showLogosDialog}
        style={{ width: "80vw" }}
        onHide={() => setShowLogosDialog(false)}
        footer={LogosDialogFooter}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
          }}
        >
          {[
            {
              titulo: "Logo Primario",
              name: "LogoPrimario",
              imagen: values.LogoPrimario,
              oscuro: false,
            },
            {
              titulo: "Logo Primario Sobre Oscuro",
              name: "LogoPrimarioDark",
              imagen: values.LogoPrimarioDark,
              oscuro: true,
            },
            {
              titulo: "Logo Primario Vertical",
              name: "LogoPrimarioVertical",
              imagen: values.LogoPrimarioVertical,
              oscuro: false,
            },
            {
              titulo: "Logo Primario Vertical Sobre Oscuro",
              name: "LogoPrimarioVerticalDark",
              imagen: values.LogoPrimarioVerticalDark,
              oscuro: true,
            },
            {
              titulo: "Logo Primario B64",
              name: "LogoPrimarioB64",
              imagen: values.LogoPrimarioB64,
              oscuro: false,
            },
            {
              titulo: "Logo Primario B64 Sobre Oscuro",
              name: "LogoPrimarioDarkB64",
              imagen: values.LogoPrimarioDarkB64,
              oscuro: true,
            },
            ].map((logo, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "12px",
                  backgroundColor: "#f8f8f8",
                }}
              >
                <h5 style={{ marginBottom: "10px" }}>{logo.titulo}</h5>

                <div
                  style={{
                    backgroundColor: logo.oscuro ? "#000" : "#fff",
                    minHeight: "220px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                    padding: "15px",
                  }}
                >
                  {logo.imagen ? (
                    <img
                      src={getImgSrc(logo.imagen)}
                      alt={logo.titulo}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "200px",
                        objectFit: "contain",
                      }}
                    />
                  ) : (
                    <span style={{ color: logo.oscuro ? "#fff" : "#666" }}>
                      Sin imagen
                    </span>
                  )}
                </div>

                <div className="mt-3">
                  <span className="p-float-label">
                    <InputText
                      name={logo.name}
                      value={values[logo.name] || ""}
                      onChange={handleInputChange}
                      style={{ width: "100%" }}
                    />
                    <label htmlFor={logo.name}>{logo.titulo}</label>
                  </span>
                </div>
              </div>
            ))}
        </div>
      </Dialog>
    </div>
  );
};

export default InformacionEmpresaCRUD;
